import {
  AddressContainer,
  CannotConfirmContainer,
  CardDetailsContainer,
  ConnectingContainer,
  ErrorContainer,
  ManualAddressContainer,
  MeterCodeContainer,
  MoveDateContainer,
  MpanContainer,
  NotCompatibleContainer,
  SystemUnavailableContainer,
  TermsContainer,
  VerifyContainer,
} from './Onboarding';
import { ConsentContext, ConsentFlows } from '../context/ConsentContext';
import { Navigate, Route, Routes } from 'react-router';
import React, { useContext, useEffect } from 'react';

import { LoginCard } from '../ui';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import ReactMarkdown from 'react-markdown';
import ReconfirmNow from './Reconfirm/ReconfirmNowContainer';
import ReconfirmSoon from './Reconfirm/ReconfirmSoonContainer';
import ReconfirmSuccess from './Reconfirm/ReconfirmSuccessContainer';
import { contentfulPropTypes } from '../propTypes';
import { getCurrentUserInfo } from '../utils/auth';
import styled from 'styled-components';
import { useContentfulTag } from '../hooks';

const StyledReactMarkdown = styled(ReactMarkdown)`
  p {
    margin-bottom: 0;
  }
`;

const ReconfirmContainer = () => {
  const {
    setUser,
    setConsentFlow,
    setHasOnboarded,
    setHasRegisterMpanTrustedConsent,
    setOnboardingDisabled,
    onboardingDisabled,
  } = useContext(ConsentContext);

  const disableOnboarding = useContentfulTag(
    'config_disable_onboarding',
    'keyValuePair',
  );

  const onboardingDisabledContent = useContentfulTag(
    'web_app_onboarding_disabled',
  );

  useEffect(() => {
    if (!disableOnboarding?.loading && disableOnboarding?.fetched) {
      setOnboardingDisabled(disableOnboarding?.contentful?.value === 'true');
    }
  }, [disableOnboarding, setOnboardingDisabled]);

  useEffect(() => {
    setHasRegisterMpanTrustedConsent(false);
    setHasOnboarded(false);
    setConsentFlow(ConsentFlows.RECONFIRM);
    getCurrentUserInfo().then(res => {
      if (res) {
        setUser(res);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <OnboardingLayout>
      <LoginCard>
        {onboardingDisabled && (
          <>
            {onboardingDisabledContent?.contentful && (
              <>
                <h1 className="mb-3">
                  {onboardingDisabledContent?.contentful?.title}
                </h1>
                <StyledReactMarkdown>
                  {onboardingDisabledContent?.contentful?.body}
                </StyledReactMarkdown>
              </>
            )}
          </>
        )}
        {!onboardingDisabled && (
          <Routes>
            <Route index element={<Navigate to="soon" replace />} />

            <Route path="soon" element={<ReconfirmSoon />} />
            <Route path="now" element={<ReconfirmNow />} />
            <Route path="address" element={<AddressContainer />} />
            <Route path="manual-address" element={<ManualAddressContainer />} />
            <Route path="move-date" element={<MoveDateContainer />} />
            <Route path="mpan" element={<MpanContainer />} />
            <Route path="not-compatible" element={<NotCompatibleContainer />} />
            <Route path="terms" element={<TermsContainer />} />
            <Route path="verify-address" element={<VerifyContainer />} />
            <Route path="card-details" element={<CardDetailsContainer />} />
            <Route path="connecting" element={<ConnectingContainer />} />
            <Route path="cannot-confirm" element={<CannotConfirmContainer />} />
            <Route path="meter-code" element={<MeterCodeContainer />} />
            <Route path="success" element={<ReconfirmSuccess />} />
            <Route path="error" element={<ErrorContainer />} />
            <Route
              path="system-unavailable"
              element={<SystemUnavailableContainer />}
            />

            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>
        )}
      </LoginCard>
    </OnboardingLayout>
  );
};

ReconfirmContainer.propTypes = {
  ...contentfulPropTypes,
};

export default ReconfirmContainer;
